import { render } from "./CategoryTwelveFileUploadDialog.vue?vue&type=template&id=1dfbce2e&scoped=true"
import script from "./CategoryTwelveFileUploadDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryTwelveFileUploadDialog.vue?vue&type=script&lang=ts"

import "./CategoryTwelveFileUploadDialog.vue?vue&type=style&index=0&id=1dfbce2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dfbce2e"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
